module.exports = __webpack_public_path__ + "static/img/khk001-2.9478f0b7.jpg";